export const convertStatus = status => {
  let convertedStatus = { label: status, color: '#303030' };
  if (status === 'waiting-disbursement') {
    convertedStatus = { label: 'Menunggu Pencairan', color: '#E3B63C' };
  } else if (status === 'ongoing') {
    convertedStatus = { label: 'Dalam Masa Pinjaman', color: '#2C465C' };
  } else if (status === 'done') {
    convertedStatus = { label: 'Lunas', color: '#2EBF2B' };
  } else if (status === 'extended') {
    convertedStatus = { label: 'Perpanjangan', color: '#2C465C' };
  } else if (status === 'payment-failed') {
    convertedStatus = { label: 'Gagal Tebus', color: '#F23434' };
  } else if (status === 'payment-late') {
    convertedStatus = { label: 'Melewati Tenor', color: '#F23434' };
  } else if (status === 'canceled') {
    convertedStatus = { label: 'Dibatalkan', color: '#F23434' };
  } else if (status === 'waiting-valuation') {
    convertedStatus = { label: 'Menunggu Valuasi', color: '#E3B63C' };
  } else if (status === 'waiting-confirmation') {
    convertedStatus = { label: 'Menunggu Konfirmasi', color: '#E3B63C' };
  } else if (status === 'disbursement-canceled') {
    convertedStatus = { label: 'Dibatalkan', color: '#F23434' };
  } else if (status === 'draft') {
    convertedStatus = { label: 'Draft', color: '#E3B63C' };
  } else if (status === 'waiting-payment') {
    convertedStatus = { label: 'Menunggu Pembayaran', color: '#FFBB03' };
  } else if (status === 'waiting-confirmation-delivery') {
    convertedStatus = { label: 'Menunggu Konfirmasi Pengiriman', color: '#FFBB03' };
  }
  return convertedStatus;
};

export const convertStatusInstallment = status => {
  let convertedStatus = { label: status, color: '#303030' };
  if (status === 'ongoing') {
    convertedStatus = { label: 'Memasuki Periode Tagihan', color: '#F23434' };
  } else if (status === 'waiting-ongoing') {
    convertedStatus = { label: 'Belum Ditagihkan', color: '#A6A6A6' };
  } else if (status === 'payment-late') {
    convertedStatus = { label: 'Melewati Jatuh Tempo', color: '#F23434' };
  } else if (status === 'payment-failed') {
    convertedStatus = { label: 'Gagal Tebus', color: '#F23434' };
  } else if (status === 'waiting-payment') {
    convertedStatus = { label: 'Menunggu Pembayaran', color: '#FFBB03' };
  } else if (status === 'done') {
    convertedStatus = { label: 'Lunas', color: '#2EBF2B' };
  }
  return convertedStatus;
};
